
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as adb2cPwJGyhyZUdBBCpFHk0IzIJbshuTw7Mj508ibU2DzlTUMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/adb2c.vue?macro=true";
import { default as _91_46_46_46slug_93fhQAvCGZcioMIFh81MWeXYHmoa0K0ryb_45zvC2_45DFQWUMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/[...slug].vue?macro=true";
import { default as static_45errorIYqpB7aprkbh5zm4z8qZO34OXbeLedHGlxyqcX4MFAcMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/static-error.vue?macro=true";
import { default as mybrita_45redirectqdVLSz98sj49P3SaKwH_t9ka0grmtAS7PP8wbpjVpggMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/r/mybrita-redirect.vue?macro=true";
import { default as static_45maintenancew5RUwujgLNSVAxNLeocm8967SOCupMgTx20M9x1qe3MMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/static-maintenance.vue?macro=true";
import { default as _91_46_46_46marketSetupLink_932hl5AF5jnS5vT9Pdn5AXVO94hS5opdGyT4ljcpmzEVgMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/r/[...marketSetupLink].vue?macro=true";
import { default as _91_46_46_46productId_93L_DQXuK2LL2IUa5AITT_45NLsDp46HGrCSUE36jGuWIF0Meta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/r/product/[...productId].vue?macro=true";
import { default as static_45yource_45maintenanceSRR9QZ4VqIkscFOVreKjL07UJ_TYquGeGkxN4TYnM7IMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/static-yource-maintenance.vue?macro=true";
export default [
  {
    name: "adb2c",
    path: "/adb2c",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/adb2c.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/[...slug].vue")
  },
  {
    name: "static-error",
    path: "/static-error",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/static-error.vue")
  },
  {
    name: "r-mybrita-redirect",
    path: "/r/mybrita-redirect",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/r/mybrita-redirect.vue")
  },
  {
    name: "static-maintenance",
    path: "/static-maintenance",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/static-maintenance.vue")
  },
  {
    name: "r-marketSetupLink",
    path: "/r/:marketSetupLink(.*)*",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/r/[...marketSetupLink].vue")
  },
  {
    name: "r-product-productId",
    path: "/r/product/:productId(.*)*",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/r/product/[...productId].vue")
  },
  {
    name: "static-yource-maintenance",
    path: "/static-yource-maintenance",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/pages/static-yource-maintenance.vue")
  }
]